module.exports = __webpack_public_path__ + "img/referenceIcon.46022e1a.png";